import { getEntries } from './array';

export const entriesToNormalizedRedmineArray = <T extends unknown>(entries: T) => (
  entries ? getEntries(entries as Record<string, string>).map(([id, name]) => ({
    id,
    name,
  })) : []
);
